import Vue from "vue";
import { post, get, upload, httpNew } from "@js/http-new.js";
import axios from "axios";

class API {
  //登录
  sendVerifyCode = (params) => post("base/sms/seed", params);
  passwordLogin = (params) => post("web/user/auth/login", params);
  verifyCodeLogin = (params) => post("web/user/auth/loginPhone", params);
  getUserInfo = (params) => get("web/user/load", params);
  logout = (params) => get("web/user/logout", params);
  //医院列表
  getHospitalList = (params) => post("web/hospital/list", params);
  //首页统计
  getCaculate = (params) => get("web/hospital/statistics", params);
  //监测中心
  getMoniterCenterData = (params) => post("web/device/monitoringCenterList", params);
  getMonitorCenterDeviceDetail = (params) =>
    get("web/device/monitoringDeviceDetail", params, { skipGlobalLoading: true });
  //设备借还
  deviceRecycle = (params) => post("web/device/recovery", params);
  deviceBorrow = (params) => post("web/device/lend", params);
  getDeviceList = (params) => post("web/device/pageList", params);
  getDeviceInfo = (params) => get("web/device/load", params);
  deleteDevice = (params) => get("web/device/del", params);
  editDevice = (params) => post("web/device/update", params);
  editDeviceInfo = (params) => post("web/device/updateInfo", params);
  stopDevice = (params) => get("web/device/stop", params);
  addDevice = (params) => post("web/device/add", params);
  //用户
  getUserList = (params) => post("web/patientUser/list", params);
  getUserPageList = (params) => post("web/patientUser/pageList", params);
  getUserDetail = (params) => get("web/patientUser/load", params);
  deleteUser = (params) => get("web/patientUser/del", params);
  createUser = (params) => post("web/patientUser/add", params);
  editUser = (params) => post("web/patientUser/update", params);

  editQueryResultUser = (params) => post("v2/flat/sleepSelfAssessment/updateUserInfo", params);
  uploadUserByExcel = (formData, hospitalId, onProgress = null) => {
    return upload(
      "web/patientUser/uploadExcel" + `?hospitalId=${hospitalId}`,
      formData,
      onProgress
    );
  };

  uploadDeviceByExcel = (formData, hospitalId, onProgress = null) => {
    return upload("web/sleepDeviceArchives/inventoryInUploadExcel", formData, onProgress);
  };
  //睡眠报告
  getSleepReportList = (params) => post("v2/web/sleepReport/list", params);
  getSleepReportPageList = (params) => post("v2/web/sleepReport/pageList", params);
  getSleepReportDetail = (params) => post("v2/web/sleepReport/detail", params);
  editReportDetail = (params) => post("v2/web/sleepReport/update", params);
  exportReport = (params) => post("v2/web/sleepReport/export", params, { responseType: "blob" }); //新加入还没接
  deleteRequest = (params) => get("v2/web/sleepReport/del", params);
  //日志
  getLogList = (params) => post("web/log/pageList", params);
  getMonitorLogList = (params) => post("web/log/monitoringList", params);
  getDeviceWarningList = (params) => post("web/log/sleepWarningLog", params);
  getPadLogList = (params) => post("web/log/handleLog", params);

  // 新版m11b分页查询监测数据
  getMonitoringList = (params) => post("web/log/m11bMonitoringList", params);

  //设置
  getLeaderInfo = (params) => get("web/user/getLeader", params);
  smsVerification = (params) => post("web/hospital/setup/smsVerification", params);
  getOrganizationConfig = (params) => get("web/hospital/setup/loadOrgSetup", params);
  editOrganizationConfig = (params) => post("web/hospital/setup/orgSetup", params);
  getSleepReportConfig = (params) => get("web/hospital/setup/loadReportSetup", params);
  editSleepReportConfig = (params) => post("web/hospital/setup/reportSetup", params);
  getBloodOxygenReportConfig = (params) => get("web/hospital/setup/loadAppReportSetup", params);
  getNewBloodOxygenReportConfig = (params) =>
    get("web/sleepOxygenReportConfig/loadByHospitalId", params);
  getBloodOxygenReportSwitchStatus = (params) => get("web/newOximetry/setup/loadSwitch", params);
  updateBloodOxygenReportSwitchStatus = (params) =>
    post("web/newOximetry/setup/updateSwitch", params);
  editBloodOxygenReportConfig = (params) => post("web/hospital/setup/appReportSetup", params);
  editNewBloodOxygenReportConfig = (params) => post("web/sleepOxygenReportConfig/update", params);
  downloadM11bRawData = (params) =>
    get("v2/web/sleepReport/downloadM11bRawData", params, { responseType: "blob" });

  addNewBloodOxygenReportConfig = (params) => post("web/sleepOxygenReportConfig/save", params);
  getDevelopConfig = (params) => get("web/hospital/setup/loadDevelopmentSetup", params);
  editDevelopConfig = (params) => post("web/hospital/setup/developmentSetup", params);
  accessFresh = (params) => get("web/hospital/setup/accessFresh", params);
  //管理
  getOrganizationList = (params) => post("web/hospital/pageList", params);
  addHospital = (params) => post("web/hospital/addOrUpdate", params);
  getHospitalDetail = (params) => get("web/hospital/load", params);
  getMenberList = (params) => post("web/user/pageList", params);
  addMember = (params) => post("web/user/addOrUpdate", params);
  getMemberDetail = (params) => get("web/user/load", params);
  deleteHospital = (params) => get("web/hospital/del", params);
  getEditonList = (params) => post("web/software/list", params);
  addNewEdition = (params) => post("web/software/save", params);
  getOrganizationTeacherList = (params) =>
    post("web/hospital/sleepHospitalInstitutionTeacher/list", params);
  getSleepHospitalNatureList = (params) => post("web/hospital/sleepHospitalNature/list", params);
  getSleepHospitalLevelList = (params) => post("web/hospital/sleepHospitalLevel/list", params);
  getSleepHospitalDepartmentList = (params) =>
    post("web/hospital/sleepHospitalDepartment/list", params);
  //设备管理
  deleteRing = (params) => get("web/sleepMonitorRing/del", params);
  addRing = (params) => post("web/sleepMonitorRing/save", params);
  getRingList = (params) => post("web/sleepMonitorRing/pageList", params);
  getChildRingList = (params) => post("web/oximetry/ring/pageList", params);


  enableQualityInspection = (params) => post("web/sleepDeviceArchives/enableQualityInspection", params)
  closeQualityInspection = (params) => post("web/sleepDeviceArchives/closeQualityInspection", params)
  completeQualityInspection = (params) => post("web/sleepDeviceArchives/completeQualityInspection", params)
  //睡眠初筛报告
  getBloodOxygenReportList = (params) => post("v2/flat/ring/xyRingReport/pageList", params);
  getBloodOxygenReportDetail = (params) => post("v2/flat/ring/xyRingReport/load", params);
  getBloodOxygenReportDownloadURL = (params) =>
    post("v2/flat/ring/xyRingReport/downloadReport", params);
  saveBloodOxygenReportSuggestion = (params) =>
    post("v2/flat/ring/xyRingReport/updateSuggest", params);
  saveBloodOxygenReportUserInfo = (params) =>
    post("v2/flat/ring/xyRingReport/updateUserInfo", params);
  exportBloodOxygenReport = (params) =>
    post("v2/flat/ring/xyRingReport/export", params, { responseType: "blob" });

  //统计分析
  getstatisticalAnalysis = (params) => post("v2/flat/sleepAssessment/statisticalAnalysis", params);

  getDeptStatAnalysis = (params) => post("v2/flat/sleepAssessment/deptStat", params);
  //下载导出结果
  downloadAssessment = (params) => post("v2/flat/sleepAssessment/downloadAssessment", params);
  downloadStatistical = (params) =>
    post("v2/flat/sleepAssessment/downloadStatistical", params, { responseType: "blob" });
  //问卷-终止任务
  endMission = (params) => post("v2/flat/sleepAssessmentTask/end", params);
  //问卷-删除任务
  deleteMission = (params) => get("v2/flat/sleepAssessmentTask/del", params);
  //生成pdf文件
  generatePdf = (params) => post("v2/base/pdf/generate", params);
  //修改密码
  changePassword = (params) => post("web/user/changePassword", params);
  //问卷筛查列表
  assessmentTaskList = (params) => post("v2/flat/sleepAssessmentTask/pageList", params);
  //获取筛查任务详情
  assessmentTaskInfo = (params) => post("v2/flat/sleepAssessmentTask/assessmentTaskInfo", params);
  //问卷-结果列表
  assessmentResultList = (params) => post("v2/flat/sleepSelfAssessment/pageList", params);
  //问卷-结果详情
  getAssessmentDetail = (params) => get("v2/flat/sleepSelfAssessment/selfLoad", params);
  //问卷-问卷列表
  assessemntList = (params) => post("v2/flat/sleepAssessment/list", params);
  //查询列表（导出问卷结果）
  assessmentListExport = (params) => post("v2/flat/sleepAssessment/reportList", params);
  //问卷-添加任务
  addTask = (params) => post("v2/flat/sleepAssessmentTask/saveOrUpdate", params);
  //问卷-在线生成PDF和PNG
  generatePDFAndPNG = (params) => get("v2/flat/sleepSelfAssessment/assessmentGenerateUrl", params);
  //良乡课题-自测结果列表
  assessmentResultLiangXiangPageList = (params) =>
    post("v2/flat/sleepSelfAssessment/liangXiangPageList", params);
  //良乡课题-自测结果详情
  getLiangXiangPageAssessmentDetail = (params) =>
    get("v2/flat/sleepSelfAssessment/liangXiangLoad", params);
  //良乡课题-下载excel
  exportLiangXiangAssessmentExcel = (params) =>
    post("v2/flat/sleepSelfAssessment/liangXiangExport", params, { responseType: "blob" });
  //良乡课题-下载pdf
  downloadLiangXiangAssessmentPdf = (params) =>
    post("v2/flat/sleepSelfAssessment/liangXiangDownloadReport", params);
  //获取当前用户登录信息
  userInfo = (params) => get("web/user/loadLoginInfo", params);
  //日志-日志列表
  logList = (params) => post("web/log/logList", params);
  //日志-添加日志
  saveLog = (params) => post("web/log/saveLog", params);
  //报告生成pdf和图片url
  reportGenerateUrl = (params) => get("v2/web/sleepReport/reportGenerateUrl", params);
  //获取机构推送配置
  loadOrgSendSetup = (params) => get("web/hospital/setup/loadOrgSendSetup", params);
  //修改机构推送配置
  orgSendSetup = (params) => post("web/hospital/setup/orgSendSetup", params);

  //血氧设备日志
  bloodOxygenDeviceLog = (params) => post("base/xyDeviceLog/pageList", params);

  //上传文件并指定文件名
  uplodFileWithNameRequest = (formData, onProgress = null) => {
    return upload("base/aly/oss/uploadFileFileName", formData, onProgress);
  };

  //获取血氧报告预览数据
  getBloodOxygenReportPreviewData = () => {
    return axios
      .get(
        "https://bajie-sleep.oss-cn-hangzhou.aliyuncs.com/%E6%96%B0%E7%89%88%E8%A1%80%E6%B0%A7%E6%8A%A5%E5%91%8A%E9%A2%84%E8%A7%88%E6%A8%A1%E7%89%88/yulanmoban.json"
      )
      .then((response) => response.data);
  };

  // 用户字段配置相关接口
  getUserFieldConfigDetail = (params) => get("web/hospital/userFieldConfig/load", params);
  getUserFieldConfigList = (params) => post("web/hospital/userFieldConfig/list", params);
  moveUserFieldConfig = (params) => post("web/hospital/userFieldConfig/move", params);
  updateUserFieldConfig = (params) => post("web/hospital/userFieldConfig/update", params);

  //人脸识别
  faceRecognition = (params) => post("base/faceRecognition/check", params);
  //推送日志
  sleepPushLogList = (params) => post("web/hospital/sleepPushLog/pageList", params);
  //机构个人微信配置管理
  getSleepHospitalGewechat = (params) =>
    get("web/hospital/sleepHospitalGewechat/loadByHospitalId", params);
  //机构个人微信配置管理-添加
  addSleepHospitalGewechat = (params) => post("web/hospital/sleepHospitalGewechat/save", params);
  //机构个人微信配置管理-修改
  updateSleepHospitalGewechat = (params) =>
    post("web/hospital/sleepHospitalGewechat/update", params);
  //获取医院微信群
  geWechatChatRooms = (params) => get("web/hospital/geWechatChatRooms", params);
  //清除医院微信群缓存
  chatRoomClearCache = (params) => get("web/hospital/chatRoomClearCache", params);
  //获取呼吸波详情
  getSleepReportBreathWave = (params) => get("v2/web/sleepReportBreathWave/loadByReportId", params);
  //异常报告标记
  getSleepExceptionClassifyList = (params) => post("v2/web/sleepExceptionClassify/list", params);
  //异常报告标记-添加
  addSleepExceptionClassify = (params) => post("v2/web/sleepReportExceptionTag/save", params);
  //异常报告标记-修改
  updateSleepExceptionClassify = (params) => post("v2/web/sleepReportExceptionTag/update", params);

  updateTaskEndTime = (params) => post("v2/flat/sleepAssessmentTask/updateEndTime", params);

  getEquipmentFileList = (params) => post("web/sleepDeviceArchives/pageList", params);

  getDeviceTypesList = (params) => post("web/sleepDeviceTypes/list", params);

  getEquipmentFileAdd = (params) => post("web/sleepDeviceArchives/save", params);

  getEquipmentFileUpdate = (params) => post("web/sleepDeviceArchives/update", params);

  getRingDeviceList = (params) => post("web/sleepDeviceArchives/ringDeviceList", params);

  getResponsiblePersonList = (params) =>
    get("web/sleepDeviceArchives/responsiblePersonList", params);

  getSleepOperationLogs = (params) => post("web/sleepOperationLogs/pageList", params);

  getMonitoringAppointmentsList = (params) => post("web/monitoringAppointment/pageList", params);

  getMonitoringAppointmentsSave = (params) => post("web/monitoringAppointment/save", params);

  getMonitoringAppointmentsUpdate = (params) => post("web/monitoringAppointment/update", params);
  // 获取AI系统提示词
  getAiSystemPrompt = (params) => {
    return get("/sleep/ai/system-prompt", params); // 使用默认配置
  };
  getCountTodayPending = (params) => get("web/monitoringAppointment/countTodayPending", params);

  // 创建AI会话
  getAiCreate = (params) => {
    return post("/sleep/ai/session/create", params); // 使用默认配置
  };

  // AI会话聊天
  getAiChat = (params, options) => {
    // 合并默认的长超时配置和用户传递的配置
    const defaultConfig = {
        timeout: 500000 // 默认5分钟超时
    }
    const mergedOptions = { ...defaultConfig, ...options }
    return post("/sleep/ai/session/chat", params, mergedOptions)
}


getAiStreamChat=(params, options)=> {
  // 合并默认的长超时配置和用户传递的配置
  const defaultConfig = {
      timeout: 500000 // 默认5分钟超时
  }
  const mergedOptions = { ...defaultConfig, ...options }
  return post("/sleep/ai/session/chat/stream", params, mergedOptions)
}
  getDeviceOutboundList = (params) => post("web/sleepDeviceArchives/stockReturn", params)

  getSleepDeviceMaintenanceOrderSave = (params) =>
    post("web/sleepDeviceMaintenanceOrder/save", params);

  getSleepDeviceMaintenanceOrderLoad = (params) =>
    get("web/sleepDeviceMaintenanceOrder/load", params);

  getSleepDeviceExceptionReasonsList = (params) => post("sleepDeviceExceptionReasons/list", params);

  getSleepDeviceMaintenanceOrderUpdate = (params) =>
    post("web/sleepDeviceMaintenanceOrder/update", params);

  getSleepDeviceMaintenanceOrderFaultCompleted = (params) =>
    post("web/sleepDeviceMaintenanceOrder/faultCompleted", params);

  getSleepDeviceArchivesLoss = (params) => post("web/sleepDeviceArchives/loss", params);
  getSleepDeviceArchivesRecover = (params) => post("web/sleepDeviceArchives/recover", params);

  getSleepDeviceArchivesAbandon = (params) => post("web/sleepDeviceArchives/abandon", params);

  getCardInfo = (params) => post("web/sleepDeviceArchives/getCardInfo", params);

  getResearchCenterList = (params) => post("/v2/web/researchCenter/pageList", params);

  getResearchCenterExport = (params) =>
    post("/v2/web/researchCenter/export", params, { responseType: "blob" });

  sleepDeviceArchivesExport = (params) =>
    post("web/sleepDeviceArchives/export", params, { responseType: "blob" });
}

Vue.prototype.$api = new API();
